import axios from "axios";
import React, { useLayoutEffect, useState } from "react";
import Loader from "../Layout/Loader";
import Login from "../Admin/Login/Login";

function ProtectedRoutes({ children }) {
  const [auth, setAuth] = useState(false);
  const [loading, setLoading] = useState(false);

  useLayoutEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) setAuth(false);
    else {
      (async function () {
        try {
          setLoading(true);
          const user = await axios.get(process.env.REACT_APP_BACKEND + "/api/v1/user", {
            headers: { token },
          });
          setAuth(user.data.success);
        } catch (error) {
          localStorage.removeItem("token");
          setAuth(false);
        } finally {
          setLoading(false);
        }
      })();
    }
  }, []);
  if (loading) return <Loader />;
  if (!auth) return <Login auth={auth} setAuth={setAuth} />;
  else return React.cloneElement(children, { setAuth });
}

export default ProtectedRoutes;
